import type { PublicProfile } from '@molt/shared';
import { profileName } from '@/components/Avatar';
import { cn } from '@/lib/cn';

export interface ProfileLinkProps {
  profile: PublicProfile;
  className?: string | undefined;
}

export function ProfileLink({ profile, className }: ProfileLinkProps) {
  return (
    <a
      href={`/users/${profile.id}`}
      className={cn(
        'font-medium text-ink underline-offset-2 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent',
        className,
      )}
    >
      {profileName(profile)}
    </a>
  );
}
